import { makeAutoObservable } from 'mobx';

class ChatStateStore {
  // 聊天状态
  isPreparing = false; // 准备中
  isUpdating = false; // 更新中
  isSwitchingConversation = false; // 会话切换中
  isInitializing = false; // 初始化中
  isConnecting = false; // 连接中
  isLoading = false; // 加载中

  // 错误状态
  error = null;

  constructor() {
    makeAutoObservable(this);
  }

  // 状态设置方法
  setPreparing = value => {
    this.isPreparing = value;
  };

  setUpdating = value => {
    this.isUpdating = value;
  };

  setSwitchingConversation = value => {
    this.isSwitchingConversation = value;
  };

  setInitializing = value => {
    this.isInitializing = value;
  };

  setConnecting = value => {
    this.isConnecting = value;
  };

  setLoading = value => {
    // 设置加载状态，同时更新相关状态
    this.isLoading = value;
    if (value) {
      // 如果开始加载，设置相关状态
      this.isInitializing = true;
    } else {
      // 如果结束加载，重置相关状态
      this.isInitializing = false;
      this.isPreparing = false;
      this.isUpdating = false;
      this.isConnecting = false;
    }
  };

  setError = error => {
    this.error = error;
  };

  // 检查是否可以执行操作
  canPerformAction = () => {
    return (
      !this.isPreparing &&
      !this.isUpdating &&
      !this.isSwitchingConversation &&
      !this.isInitializing &&
      !this.isConnecting
    );
  };

  // 检查是否可以切换会话
  canSwitchConversation = () => {
    return !this.isSwitchingConversation && !this.isInitializing && !this.isUpdating;
  };

  // 宽松的用户交互检查 - 只检查是否正在切换会话
  canHandleUserInteraction = () => {
    // 更宽松的检查：只要不是正在切换会话就允许交互
    // 其他状态（如加载、更新等）不应该阻止用户点击
    return !this.isSwitchingConversation;
  };

  // 重置所有状态
  reset = () => {
    this.isPreparing = false;
    this.isUpdating = false;
    this.isSwitchingConversation = false;
    this.isInitializing = false;
    this.isConnecting = false;
    this.error = null;
  };

  // 重置所有状态（用于刷新操作）
  resetAllStates = () => {
    // 重置切换相关状态
    this.isSwitchingConversation = false;
    this.isUpdating = false;
    this.isConnecting = false;
    this.isPreparing = false;
    this.isInitializing = false;
    this.isLoading = false;
    // 重置错误状态
    this.error = null;
  };

  // 获取当前状态描述
  getCurrentStateDescription = () => {
    if (this.isPreparing) return '准备中';
    if (this.isUpdating) return '更新中';
    if (this.isSwitchingConversation) return '会话切换中';
    if (this.isInitializing) return '初始化中';
    if (this.isConnecting) return '连接中';
    return '就绪';
  };
}

export const chatStateStore = new ChatStateStore();
